import { BaseDto } from '@/shared/dtos/base-dto';

export class crm_actividades extends BaseDto {
    public client_id!: number;
    public id_oportunidad!: number | null;
    public tipo!: string;
    public fecha!: Date;
    public descripcion_notas!: string;
}
